import { StartTradingRegister, ValidateEmail } from "@/api/forms";
import { api } from "@/forms/api";
import { backendErrors } from "./common";

export const START_TRADING_STEPS = {
  FIRST_STEP: "FIRST_STEP",
  VERIFY_STEP: "VERIFY_STEP",
  SECOND_STEP: "SECOND_STEP",
  THANK_YOU_STEP: "THANK_YOU_STEP"
};

export const startTradingFirstStep = async (data: ValidateEmail) => {
  const { data: validateData } = await api.forms.validateEmailStartTrading(
    data
  );

  if (validateData.errors) {
    throw { errors: backendErrors(validateData.errors) };
  }

  if (!validateData.success) {
    return {
      next: START_TRADING_STEPS.SECOND_STEP,
      data
    };
  }

  if (!validateData.is_verified_email) {
    throw { code: "email_exists" };
  }

  const { data: thankYouData } = await api.forms.startTradingThankYou({
    user_id: validateData.id,
    preDefinedPayload: data.preDefinedPayload
  });

  return {
    next: START_TRADING_STEPS.THANK_YOU_STEP,
    data: { ...validateData, ...thankYouData }
  };
};

export const startTradingRegisterStep = async (data: StartTradingRegister) => {
  const { data: registerData } = await api.forms.startTradingRegister(data);

  if (registerData.errors) {
    throw { errors: backendErrors(registerData.errors) };
  }

  if (!registerData.success) {
    throw new Error("Register error");
  }

  const { data: thankYouData } = await api.forms.startTradingThankYou({
    user_id: registerData.id,
    preDefinedPayload: data.preDefinedPayload
  });

  return {
    next: START_TRADING_STEPS.THANK_YOU_STEP,
    data: { ...registerData, ...thankYouData }
  };
};
